import { render, staticRenderFns } from "./InputView.vue?vue&type=template&id=c7ce2ee8&"
import script from "./InputView.vue?vue&type=script&lang=js&"
export * from "./InputView.vue?vue&type=script&lang=js&"
import style0 from "./InputView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c7ce2ee8', component.options)
    } else {
      api.reload('c7ce2ee8', component.options)
    }
    module.hot.accept("./InputView.vue?vue&type=template&id=c7ce2ee8&", function () {
      api.rerender('c7ce2ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/InputView.vue"
export default component.exports